import BModal from './BModal'
import BPopover from './BPopover'
import BToggle from './BToggle'
import BTooltip from './BTooltip'
import BVisible from './BVisible'
import focus from './focus'

export {BModal, BPopover, BToggle, BTooltip, BVisible, focus}

export default {
  BModal,
  BPopover,
  BToggle,
  BTooltip,
  BVisible,
  focus,
}
